import { Box, Input } from "@chakra-ui/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../components/Models/main-model";
import { closeAddVoucherModel } from "../../../modules/admin-modules/models/Actions";
import { addVoucherRequest } from "../../../modules/students-modules/videos/Actions";

const AddVoucher = ({ video_id }) => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.model.isOpen21);
  const [voucherData, setVoucherData] = useState();
  const voucherLoading = useSelector(
    (state) => state.chapterVideos.voucherLoading
  );
  const handelSendVoucher = () => {
    let formData = new FormData();
    formData.append("voucher", voucherData);
    formData.append("video_id", video_id);

    dispatch(
      addVoucherRequest({
        formData: {
          formData: formData,
        },
        action: () => {
          dispatch(closeAddVoucherModel());
        },
      })
    );
  };

  const header = <Box></Box>;

  const closeFunc = () => {
    dispatch(closeAddVoucherModel());
  };
  return (
    <MainModel
      header={header}
      closeFunc={closeFunc}
      openVar={isOpen}
      buttonTitle={"Save"}
      buttonFunc={handelSendVoucher}
      size="md"
      isLoading={voucherLoading}
    >
      <Input
        placeholder=" add voucher code"
        style={{
          width: "100%",
          padding: "20px",
          objectFit: "contain",
          borderRadius: "10px",
          boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
          border: "solid 1px #010038",
          backgroundColor: "#fff",
        }}
        onChange={(e) => setVoucherData(e?.target?.value)}
      />
    </MainModel>
  );
};

export default AddVoucher;
